import { StockSymbol } from '@benzinga/session';
import { Watchlist, WatchlistId } from './entities';
import { WatchlistSymbol } from './entities';
import { IncomingWatchlist, IncomingWatchlistSymbol } from './ingest';

export const toWatchlistAlertName = (symbol: StockSymbol): StockSymbol => {
  if (typeof symbol === 'string' && symbol.includes('/USD')) {
    return `$${symbol.split('/')[0]}` as StockSymbol;
  }
  return symbol;
};

export interface EgressAddTickerToWatchlistData {
  alert_name: StockSymbol;
  portfolio_id: WatchlistId;
  status: boolean;
  type: 'ticker';
}

export const egressAddTickerToWatchlist = (
  watchlist: Watchlist,
  ticker: StockSymbol[],
): EgressAddTickerToWatchlistData[] => {
  return ticker.map(ticker => ({
    alert_name: toWatchlistAlertName(ticker),
    portfolio_id: watchlist.watchlistId,
    status: true,
    type: 'ticker',
  }));
};

export type EgressWatchlistSymbol = Partial<IncomingWatchlistSymbol>;

export const egressUpdateWatchlistTicker = (watchlistSymbol: Partial<WatchlistSymbol>): EgressWatchlistSymbol => ({
  alert_id: watchlistSymbol.symbolId,
  alert_name: watchlistSymbol.symbol,
  is_bz: watchlistSymbol.isBZ ?? undefined,
  is_bzpro: watchlistSymbol.isBZPro ?? undefined,
  is_pr: watchlistSymbol.isPR ?? undefined,
  is_sec: watchlistSymbol.isSEC ?? undefined,
  portfolio_id: watchlistSymbol.watchlistId,
  send_realtime: watchlistSymbol.sendRealtime ?? undefined,
  status: watchlistSymbol.status ?? undefined,
  type: 'ticker',
});

export type EgressWatchlist = Partial<IncomingWatchlist>;

export const egressUpdateWatchlistSettings = (watchlist: Partial<Watchlist>): EgressWatchlist => ({
  portfolio_id: watchlist.watchlistId,
  portfolio_name: watchlist.name,
  realtime_bz: watchlist.realtimeBZ ? 1 : 0,
  realtime_pr: watchlist.realtimePR ? 1 : 0,
  realtime_sec: watchlist.realtimeSEC ? 1 : 0,
  send_summary: watchlist.emailSummary ? 1 : 0,
  sound: watchlist.sound,
});
